(function () {
  'use strict';

  function initProductGallery() {
    var track = document.querySelector('.vg-track');
    var slides = document.querySelectorAll('.vg-slide');
    var thumbs = document.querySelectorAll('.vg-thumb');
    var prevBtn = document.querySelector('.vg-arrow--prev');
    var nextBtn = document.querySelector('.vg-arrow--next');

    if (!track || slides.length === 0) return;

    var current = 0;
    var total = slides.length;
    var navigating = false; // suppresses IntersectionObserver during programmatic scrolls
    var navTimer = null;
    var userNavigated = false; // true once the shopper touches the gallery themselves

    // ── Activate slide & matching thumb ──────────────────────────────────────
    function activate(index, behavior) {
      behavior = behavior || 'instant';
      if (index < 0) index = total - 1;
      if (index >= total) index = 0;
      current = index;

      // Suppress the IntersectionObserver for the duration of the scroll animation
      navigating = true;
      clearTimeout(navTimer);
      navTimer = setTimeout(function () { navigating = false; }, behavior === 'smooth' ? 600 : 50);

      slides.forEach(function (s, i) {
        s.classList.toggle('vg-slide--active', i === current);
        s.setAttribute('aria-hidden', i === current ? 'false' : 'true');
        s.querySelectorAll('[data-gallery-target]').forEach(function (button) {
          button.setAttribute('tabindex', i === current ? '0' : '-1');
        });
      });

      thumbs.forEach(function (t, i) {
        var isActive = i === current;
        t.classList.toggle('vg-thumb--active', isActive);
        t.setAttribute('aria-selected', isActive ? 'true' : 'false');
        t.setAttribute('tabindex', isActive ? '0' : '-1');
        var dot = t.querySelector('.vg-dot');
        if (dot) dot.style.display = isActive ? 'block' : 'none';
      });

      // Scroll main slide into view
      scrollWithin(track, slides[current], 'start', behavior);

      // Scroll active thumb into view in the strip
      if (thumbs[current]) {
        scrollWithin(thumbs[current].parentElement, thumbs[current], 'nearest', 'smooth');
      }
    }

    // Scroll el into view inside its own horizontal strip only. scrollIntoView
    // also scrolls the window, so on load (and on every slide change) it
    // nudged the whole product page down whenever the thumbnails sat just
    // below the fold.
    function scrollWithin(container, el, align, behavior) {
      if (!container || !el) return;
      var c = container.getBoundingClientRect();
      var r = el.getBoundingClientRect();
      var delta;
      if (align === 'start') delta = r.left - c.left;
      else if (r.left < c.left) delta = r.left - c.left;
      else if (r.right > c.right) delta = r.right - c.right;
      else return;
      if (Math.abs(delta) < 1) return;
      try {
        container.scrollTo({ left: container.scrollLeft + delta, behavior: behavior });
      } catch (err) {
        container.scrollLeft += delta;
      }
    }

    // ── Arrow buttons — smooth scroll on click ────────────────────────────────
    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        userNavigated = true;
        activate(current - 1, 'smooth');
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        userNavigated = true;
        activate(current + 1, 'smooth');
      });
    }

    // ── Thumbnail clicks ──────────────────────────────────────────────────────
    thumbs.forEach(function (thumb, i) {
      thumb.addEventListener('click', function () {
        userNavigated = true;
        activate(i);
      });
      // Also support keyboard activation via Enter/Space
      thumb.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          userNavigated = true;
          activate(i);
        }
      });
    });

    track.addEventListener('click', function (event) {
      var button = event.target.closest('[data-gallery-target]');
      if (!button || !track.contains(button)) return;
      var targetId = button.getAttribute('data-gallery-target');
      for (var i = 0; i < slides.length; i++) {
        if (slides[i].getAttribute('data-media-id') === targetId) {
          event.preventDefault();
          userNavigated = true;
          activate(i);
          if (thumbs[i]) thumbs[i].focus({ preventScroll: true });
          break;
        }
      }
    });

    // ── IntersectionObserver: sync state when user swipes natively ────────────
    // Uses 'instant' so we don't double-scroll (CSS scroll-snap already handled the swipe)
    // Skips during programmatic navigation to prevent wrap-around race condition
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        var topEntry = null;
        entries.forEach(function (entry) {
          if (entry.isIntersecting && !navigating) {
            if (!topEntry || entry.intersectionRatio > topEntry.intersectionRatio) {
              topEntry = entry;
            }
          }
        });

        if (topEntry) {
          var idx = Array.prototype.indexOf.call(slides, topEntry.target);
          if (idx !== -1 && idx !== current) {
            activate(idx, 'instant');
          }
        }
      }, { root: track, threshold: 0.5 });

      slides.forEach(function (s) { io.observe(s); });
    }

    ['pointerdown', 'touchstart', 'wheel'].forEach(function (evt) {
      track.addEventListener(evt, function () { userNavigated = true; }, { passive: true });
    });

    // ── Keyboard navigation — smooth scroll ───────────────────────────────────
    document.addEventListener('keydown', function (e) {
      var gallery = e.target.closest('.product-images-hlf-container');
      if (!gallery) return;

      var el = document.activeElement;
      if (el && (
        el.tagName === 'INPUT' ||
        el.tagName === 'TEXTAREA' ||
        el.tagName === 'SELECT' ||
        el.isContentEditable ||
        el.getAttribute('role') === 'textbox'
      )) return;
      if (e.key === 'ArrowLeft') {
        e.preventDefault();
        userNavigated = true;
        activate(current - 1, 'smooth');
      }
      if (e.key === 'ArrowRight') {
        e.preventDefault();
        userNavigated = true;
        activate(current + 1, 'smooth');
      }
    });

    // ── Variant featured-image sync ───────────────────────────────────────────
    // Products whose variants carry featured media (e.g. the Ultimate disc's
    // Print Area option) emit a {variantId: mediaId} JSON map next to the
    // gallery; slides carry data-media-id. Jump to the matching slide when the
    // variant changes, and start there on load so the photo matches the
    // preselected variant. Products without variant media get an empty map and
    // keep the old behavior exactly.
    var mapEl = document.querySelector('script[data-vg-variant-media]');
    var variantSelect = document.querySelector('select[name="id"]');
    var variantMedia = {};
    if (mapEl) {
      try { variantMedia = JSON.parse(mapEl.textContent) || {}; } catch (err) { variantMedia = {}; }
    }
    function slideForVariant(variantId) {
      var mediaId = variantMedia[variantId];
      if (!mediaId) return -1;
      for (var i = 0; i < slides.length; i++) {
        if (slides[i].getAttribute('data-media-id') === String(mediaId)) return i;
      }
      return -1;
    }
    function syncToVariant() {
      var idx = slideForVariant(variantSelect.value);
      if (idx !== -1 && idx !== current) { userNavigated = true; activate(idx, 'smooth'); }
    }
    if (variantSelect) {
      variantSelect.addEventListener('change', syncToVariant);
      // Shopify.OptionSelectors writes the master select's value silently -
      // no native change event ever fires on it - so in-page option changes
      // never reached the listener above (it only helped code that dispatches
      // a real event). Watch the visible option dropdowns and swatch inputs
      // instead; capture phase fires before OptionSelectors' own handler has
      // updated the master select, so defer one tick before reading it.
      document.addEventListener('change', function (e) {
        var t = e.target;
        if (!t || t === variantSelect || !t.matches) return;
        if (t.matches('.single-option-selector') || (t.closest && t.closest('.swatch'))) {
          setTimeout(syncToVariant, 0);
        }
      }, true);
    }

    // Init on the selected variant's slide when it has one, else the first.
    // This runs at DOMContentLoaded, before images have laid out, so the
    // scrollIntoView can no-op and the IntersectionObserver then snaps back to
    // slide 0 once images arrive - re-assert after the full load unless the
    // shopper has navigated the gallery themselves in the meantime.
    var initIdx = variantSelect ? slideForVariant(variantSelect.value) : -1;
    activate(initIdx !== -1 ? initIdx : 0);
    if (initIdx !== -1) {
      window.addEventListener('load', function () {
        if (userNavigated) return;
        var idx = variantSelect ? slideForVariant(variantSelect.value) : -1;
        if (idx !== -1 && idx !== current) activate(idx, 'instant');
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductGallery);
  } else {
    initProductGallery();
  }
})();
